export const ACCESS_TOKEN = 'ACCESS_TOKEN';
export const UID = 'UID';
export const CLIENT = 'CLIENT';
export const CURRENT_STEP = 'CURRENT_STEP';
export const PATH = 'PATH';
export const ACCOUNT = 'ACCOUNT';
export const LOCATION = 'LOCATION';
export const MENU = 'MENU';
export const BUSINESS_KIND = 'BUSINESS_KIND';
export const BUSINESS_AGE = 'BUSINESS_AGE';
export const RESERVATIONS = 'RESERVATIONS';
export const ERB_PROVIDER = 'ERB_PROVIDER';
export const PRIVATE_ROOMS = 'PRIVATE_ROOMS';
export const BEO_PROVIDER = 'BEO_PROVIDER';
export const PUBLIC_EVENTS = 'PUBLIC_EVENTS';
export const DIGITAL_GIFT_CARDS = 'DIGITAL_GIFT_CARDS';
export const DIGITAL_GIFT_CARDS_PROVIDER = 'DIGITAL_GIFT_CARDS_PROVIDER';
export const PHYSICAL_GIFT_CARDS = 'PHYSICAL_GIFT_CARDS';
export const PHYSICAL_GIFT_CARDS_PROVIDER = 'PHYSICAL_GIFT_CARDS_PROVIDER';
export const IS_CATERING_ORDERS = 'IS_CATERING_ORDERS';
export const CATERING_MENUS = 'CATERING_MENUS';
export const IS_PICKUP_ORDERS = 'IS_PICKUP_ORDERS';
export const PICKUP_MENUS = 'PICKUP_MENUS';
export const IS_DELIVERY_ORDERS = 'IS_DELIVERY_ORDERS';
export const IS_DELIVERY_DRIVER = 'IS_DELIVERY_DRIVER';
export const DELIVERY_PICKUP_THIRD_PARTY = 'DELIVERY_PICKUP_THIRD_PARTY';
export const DELIVERY_PICKUP_SERVICES_LIST = 'DELIVERY_PICKUP_SERVICES_LIST';
export const IS_HIRING_PAGE = 'IS_HIRING_PAGE';
export const STORAGE_ACCOUNT_EMAIL = 'ACCOUNT_EMAIL';
export const DEFAULT_EMAIL = 'DEFAULT_EMAIL';

const STORAGE = sessionStorage;

export const set = (key, payload) => {
  STORAGE.setItem(key, payload);
};

export const get = (key, defaultValue = '') => STORAGE.getItem(key) || defaultValue;
